var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientDemographics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 228,
    viewBox: "0 0 229 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4673_12848)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4673_12848",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 229,
    height: 228
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.260254 1.36608e-05H228.26V228H0.260254V1.36608e-05Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4673_12848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.292 208.773H186.162C188.806 208.773 190.95 206.63 190.95 203.985V62.7123",
    stroke: "#7f56d9",
    strokeWidth: 6.67969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0322 189.712V203.985C43.0322 206.63 45.1755 208.773 47.8202 208.773H97.4534",
    stroke: "#7f56d9",
    strokeWidth: 6.67969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.95 46.8738V8.13251C190.95 5.4878 188.807 3.3445 186.162 3.3445H47.8202C45.1755 3.3445 43.0322 5.4878 43.0322 8.13251V95.1523",
    stroke: "#7f56d9",
    strokeWidth: 6.67969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.969 70.1406C140.927 67.1717 149.791 56.3698 149.791 43.4937C149.791 28.3284 137.497 16.0346 122.331 16.0346C107.166 16.0346 94.8716 28.3284 94.8716 43.4937C94.8716 56.3694 103.735 67.1709 115.693 70.1403",
    stroke: "#7f56d9",
    strokeWidth: 5.59895,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1716 108.291C56.1716 115.548 50.2894 121.43 43.0331 121.43C35.7772 121.43 29.895 115.548 29.895 108.291C29.895 101.035 35.7772 95.1531 43.0331 95.1531C50.2894 95.1531 56.1716 101.035 56.1716 108.291Z",
    stroke: "#7f56d9",
    strokeWidth: 6.67969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3754 153.511L62.5697 133.226C61.9748 126.547 56.3794 121.427 49.6735 121.427H36.3907C29.6856 121.427 24.0894 126.547 23.4949 133.226L21.6891 153.511C21.5542 155.025 22.7476 156.329 24.2684 156.329H30.4155V184.532C30.4155 187.392 32.7342 189.711 35.5945 189.711H50.4701C53.3304 189.711 55.6491 187.392 55.6491 184.532V156.329H61.7966C63.3169 156.329 64.5108 155.025 64.3754 153.511Z",
    stroke: "#7f56d9",
    strokeWidth: 6.67969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0322 156.087V189.711",
    stroke: "#7f56d9",
    strokeWidth: 6.67969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.637 105.688H89.0406C84.2764 105.688 80.416 103.677 80.416 101.197V92.4764C80.416 89.997 84.2764 87.9863 89.0406 87.9863H163.637C168.4 87.9863 172.262 89.997 172.262 92.4764V101.197C172.262 103.677 168.4 105.688 163.637 105.688Z",
    stroke: "#7f56d9",
    strokeWidth: 6.67969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.895 131.5L172.358 131.5",
    stroke: "#7f56d9",
    strokeWidth: 6.67969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0088 147.508L172.262 147.508",
    stroke: "#7f56d9",
    strokeWidth: 6.67969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7559 162.809H172.358",
    stroke: "#7f56d9",
    strokeWidth: 6.67969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7559 177.945H172.358",
    stroke: "#7f56d9",
    strokeWidth: 6.67969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4673_12848"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 228,
    height: 228,
    fill: "white",
    transform: "translate(0.261719)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientDemographics);
export default __webpack_public_path__ + "static/media/patientDemographics.d198046a6edff9884c2ff8b8f6500295.svg";
export { ForwardRef as ReactComponent };